exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".toggle-buttons-toggle-buttons-4OP3EY2bmwr{display:flex}.toggle-buttons-toggle-buttons-4OP3EY2bmwr .toggle-buttons-toggle-button-7jQuqTVjmwr{min-width:0}.toggle-buttons-toggle-button-7jQuqTVjmwr{padding:6px}.toggle-buttons-toggle-button-7jQuqTVjmwr:not(.toggle-buttons-selected-4iytDV1xmwr) path{fill:rgba(0,0,0,0.59)}.toggle-buttons-toggle-button-7jQuqTVjmwr:not(.toggle-buttons-first-3ViMilwLmwr):not(.toggle-buttons-last-6sOv60Xzmwr){border-radius:0}.toggle-buttons-first-3ViMilwLmwr{border-top-right-radius:0;border-bottom-right-radius:0}.toggle-buttons-last-6sOv60Xzmwr{border-top-left-radius:0;border-bottom-left-radius:0}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"toggle-buttons": "toggle-buttons-toggle-buttons-4OP3EY2bmwr",
	"toggleButtons": "toggle-buttons-toggle-buttons-4OP3EY2bmwr",
	"toggle-button": "toggle-buttons-toggle-button-7jQuqTVjmwr",
	"toggleButton": "toggle-buttons-toggle-button-7jQuqTVjmwr",
	"selected": "toggle-buttons-selected-4iytDV1xmwr",
	"first": "toggle-buttons-first-3ViMilwLmwr",
	"last": "toggle-buttons-last-6sOv60Xzmwr"
};